import { render, staticRenderFns } from "./px-matching-interest-removal-modal.vue?vue&type=template&id=64896659&scoped=true&"
import script from "./px-matching-interest-removal-modal.vue?vue&type=script&lang=ts&"
export * from "./px-matching-interest-removal-modal.vue?vue&type=script&lang=ts&"
import style0 from "./px-matching-interest-removal-modal.vue?vue&type=style&index=0&id=64896659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64896659",
  null
  
)

export default component.exports